var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgImportedFiles = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#637079",
    fillRule: "evenodd",
    d: "M35 14.808H9.844V30.06a1.1 1.1 0 0 1-.323.78 1.1 1.1 0 0 1-.77.324 1.1 1.1 0 0 1-.772-.325 1.1 1.1 0 0 1-.323-.779V8.831h5.342l2.5 3.775h13.096v1.258h2.813v-4.09H17.003L14.503 6H5v25.158c.182.63.52 1.211.99 1.684a3.9 3.9 0 0 0 2.756 1.154h.004l1.402.004v-.004h21.102a3.9 3.9 0 0 0 2.756-1.154c.47-.472.807-1.053.99-1.683zM12.657 30.064V17.639h19.687V30.06a1.1 1.1 0 0 1-.323.78 1.1 1.1 0 0 1-.773.324h-18.75c.103-.353.157-.722.158-1.097v-.004Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImportedFiles);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/imported-files.ee844c70.svg";